import { IconProps } from '@/components/Icons/types/IconInterface';
import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';

interface CloseIconProps extends IconProps {
  onClick: () => void;
}

const CloseIcon: React.FC<CloseIconProps> = ({ variant, size, className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={cn(iconVariant({ variant, size, className }))}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.10225 4.10225C4.32192 3.88258 4.67808 3.88258 4.89775 4.10225L9 8.2045L13.1023 4.10225C13.3219 3.88258 13.6781 3.88258 13.8977 4.10225C14.1174 4.32192 14.1174 4.67808 13.8977 4.89775L9.7955 9L13.8977 13.1023C14.1174 13.3219 14.1174 13.6781 13.8977 13.8977C13.6781 14.1174 13.3219 14.1174 13.1023 13.8977L9 9.7955L4.89775 13.8977C4.67808 14.1174 4.32192 14.1174 4.10225 13.8977C3.88258 13.6781 3.88258 13.3219 4.10225 13.1023L8.2045 9L4.10225 4.89775C3.88258 4.67808 3.88258 4.32192 4.10225 4.10225Z"
        fill="#010F55"
      />
    </svg>
  );
};

export default CloseIcon;
